import React, { Component, Fragment } from 'react';
import classnames from 'classnames';
import LoginPopover from './LoginPopover';
import BZPopover from 'web-common/bizzabo-components/components/BZPopover';
import {
    SESSIONS_TAB_ALL,
    SESSIONS_TAB_FAVOURITES,
    SESSIONS_TAB_REGISTRATIONS,
    loginClickOrigin,
} from 'constants/Enums';
import {
    sendCustomClick
} from '../../../utils/SnowplowUtils';
import {
    buttonTypes,
    agendaTabButtonSubCategory
} from '../../../constants/SnowplowConst';


const menuButtons = [
    {
        text: <span>All Sessions</span>,
        value: SESSIONS_TAB_ALL,
        cls: 'all-sessions-button',
        iconOnCls: 'icon-AgendaAtt_sessionOn',
        iconOffCls: 'icon-AgendaAtt_session',
        shouldBeWrapped: false
    },
    {
        text: <span>My Interests</span>,
        value: SESSIONS_TAB_FAVOURITES,
        cls: 'my-interests-button',
        iconOnCls: 'icon-lead_on',
        iconOffCls: 'icon-lead_off',
        shouldBeWrapped: true
    },
    {
        text: <span>
            <span className='sm-hidden'>My </span>
            <span>Registered</span>
            <span className='sm-hidden'> Sessions</span>
        </span>,
        value: SESSIONS_TAB_REGISTRATIONS,
        cls: 'my-registrations-button',
        iconOnCls: 'icon-Chair_ON',
        iconOffCls: 'icon-Chair_OFF',
        shouldBeWrapped: true
    }
];


export default class TabButtons extends Component {

    tabButtonClickHandler = e => {
        const { activeTab, me, ids } = this.props;
        const newTab= e.currentTarget.value || SESSIONS_TAB_ALL;
        sendCustomClick(buttonTypes.agendaTabButtons, agendaTabButtonSubCategory[newTab], e.currentTarget);
        const isAuthenticated = !!me.id;
        const isClickOnAnotherTab = activeTab !== newTab;
        if (isClickOnAnotherTab && isAuthenticated) {
            this.props.changeActiveTab(e.currentTarget.value, ids);
        }
    };

    loginButtonClickHandler = () => this.props.showEmailLogin();


    render() {
        const {
            activeTab,
            sessionsTotal,
            me,
            eventUrls,
            isSessionRegistrationEnabled,
            isLoading,
            sessionsToRender,
            setLoginV2OffsetTop,
            siteConf: { isWidget }
        } = this.props;

        return <div className='tab-buttons-container margin-bottom-small'>
            {
                menuButtons.map(({ value, iconOnCls, iconOffCls, cls, text, shouldBeWrapped }, index) => {
                    if (!isSessionRegistrationEnabled && value === 'registrations') {
                        return null;
                    }
                    const isSelected = activeTab === value;
                    const iconCls = classnames('icon custom-color color-1', {
                        [iconOnCls]: isSelected,
                        [iconOffCls]: !isSelected,
                    });

                    const menuButton = (
                        <div>
                            <button
                                className={`tab-button ${cls}`}
                                value={value}
                                onClick={this.tabButtonClickHandler}>
                                <i className={iconCls}/>
                                {text}
                                {
                                    isSelected && sessionsTotal && !isLoading
                                        ? <span className='session-counter hidden-sm hidden-xs'>
                                            {sessionsToRender.length === 0
                                                ? ` (0)`  // eslint-disable-line
                                                : ` (${sessionsTotal})`}
                                        </span>
                                        : null
                                }
                            </button>
                            <div className='session-counter-mobile hidden-md hidden-lg'>
                                {isSelected && sessionsTotal && !isLoading
                                    ? sessionsToRender.length === 0
                                        ? ` (0)`  // eslint-disable-line
                                        : ` (${sessionsTotal})`
                                    : null}
                            </div>
                        </div>
                    );
                    return <div key={index} className='tab-button-wrapper padding-horizontal-small'>
                        {
                            shouldBeWrapped
                                ? me.id
                                    ? menuButton
                                    : <BZPopover
                                        placement="bottom"
                                        cls="need-login-popover"
                                        button={menuButton}
                                        popover={
                                            <LoginPopover
                                                analyticData={{
                                                    clickOrigin: shouldBeWrapped && value === SESSIONS_TAB_REGISTRATIONS
                                                        ? loginClickOrigin.agenda.registerTab
                                                        : loginClickOrigin.agenda.interestTab
                                                }}
                                                onLoginClick={this.loginButtonClickHandler}
                                                eventUrls={eventUrls}
                                                setLoginV2OffsetTop={setLoginV2OffsetTop}
                                                isWidget={isWidget}
                                            />
                                        }
                                    />
                                : menuButton
                        }
                        <div className={`tab-button-border ${isSelected ? 'custom-color color-1-background': 'background-color-gray'}`} />
                    </div>;
                })
            }
        </div>;
    }
}
